import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import { setPreference, userPref } from "../../api";
import Pace from 'react-pace-progress'
import NavBar from "./navbar";
import { isAuthenticated, clearLocalJwt } from "../../api";
import AvatarDisplay from "../../common/avatarDisplay"

class Header extends Component {

    constructor(props) {
        super(props);
        var jwt = JSON.parse(localStorage.getItem("jwt"));
        this.openNav = this.openNav.bind(this);
        this.closeNav = this.closeNav.bind(this);
        this.gotoDashboard = this.gotoDashboard.bind(this);

        this.state = {
            isLoading: true,
            isLoggedIn: false,
            cartChange: this.props.cartChange,
            darktheme: userPref('darktheme'),
            cartCount: (jwt && jwt.user)?jwt.user.cartCount:0,
            navClose: { right: '0px' },
            user: jwt ? jwt.user : null
        }

    }

    gotoDashboard() {
        this.props.history.push(`/pages/dashboard`)

    }
    
    openNav() {
        this.setState({ navClose: { right: '0px' } })
    }
    
    closeNav() {
        this.setState({ navClose: { right: '-410px' } })
    }

    
    openFilter = () => {
        const cf = document.querySelector(".collection-filter")
        if (cf) cf.style = "left: -15px";
    }
    closeFilter = () => {
        const cf = document.querySelector(".collection-filter")
        if (cf) cf.style = "left: -365px";
    }

    changeTheme() {
        setPreference('darktheme', !this.state.darktheme );
        this.setState({
            darktheme:!this.state.darktheme
        })
    }

    componentDidUpdate(prevProps) {
        if(prevProps.cartChange !== this.props.cartChange) {
            // TODO: what is this about?
            //var jwt = JSON.parse(localStorage.getItem("jwt"));
            this.setLoggedInState();
        }
    }

    componentDidMount() {
        this.setLoggedInState();
    }

    setLoggedInState() {
        isAuthenticated().then(d2 => {
            if (d2 && d2.error) {
                console.log(d2.error);
                clearLocalJwt();
                this.setState({isLoggedIn: false, cartChange: this.props.cartChange, cartCount: 0, isLoading: false })
            } else {
                if (!d2.authenticated) clearLocalJwt();
                var jwt = JSON.parse(localStorage.getItem("jwt"));

                this.setState({isLoggedIn: d2.authenticated, cartChange: this.props.cartChange, user: jwt ? jwt.user : null, cartCount: jwt?jwt.user.cartCount:0, isLoading: false })
            }
        });
    }

    render() {
        if(this.state.darktheme){
            document.body.classList.add('dark');
        }else{
            document.body.classList.remove('dark');
        } 
        if (this.state.loading) { return null; }

        const {isLoggedIn} = this.state;
        return (
            <div>
                <header id="sticky" className="sticky header-2 header-6">
                    {this.state.isLoading ? <Pace color="#27ae60"/> : null}
                    
                    <div className="top-header top-header-dark3">
                        <div className="container-fluid">
                            <div className="row" style={{paddingRight: "15px"}}>
                                <div className="col-md-5 d-none d-lg-block">
                                    <div className="header-contact">
                                        <ul>
                                            {window.location.pathname === "/" 
                                            ?   <li className="detailAttribute">Welcome to Lasting Impact<em>!</em></li>
                                            :   <li className="detailAttribute"><img src={`${process.env.PUBLIC_URL}/assets/images/icon/logo/smaller-bubble-logo.png`} alt="" className="img-fluid" /></li>
                                            }
                                            { /* <li className="detailAttribute"><i className="fa fa-phone" aria-hidden="true"></i>Call Us: 563-663-5120</li> */ }
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-7 text-right header-contact">                        
                                    <i className="fa fa-columns panelbar" ></i> <span className="panelbar" style={{color: 'white'}} onClick={this.openFilter}>Panel</span>&nbsp;&nbsp;&nbsp;                           
                                    {/* TODO: LI add cart back in
                                    <i className="fa fa-shopping-cart" ></i> <Link style={{color: 'white'}} to={`${process.env.PUBLIC_URL}/cart`}>Cart</Link><span className="badge badge-pill badge-warning">{this.state.cartCount}</span>&nbsp;&nbsp;&nbsp;
                                    */}
                                    {/*
                                    <i className="fa fa-dashboard" ></i> <Link style={{color: 'white'}} to={`${process.env.PUBLIC_URL}/pages/dashboard`}>Dashboard</Link>&nbsp;&nbsp;&nbsp;                           
                                    */}
{/*                                    <i className={this.state.darktheme?"fa fa-eye":"fa fa-eye-slash"} ></i> <span style={{color: 'white', cursor: 'pointer'}} to='' onClick={() => this.changeTheme()}>{this.state.darktheme?'Light':'Dark'}</span>&nbsp;&nbsp;&nbsp;&nbsp; */}
                                    {this.state.user && <><Link to={`${process.env.PUBLIC_URL}/pages/dashboard`}><AvatarDisplay userId={this.state.user._id} size={40}/></Link>&nbsp;&nbsp;&nbsp;&nbsp; </>}
                                    <Link style={{color: 'white'}} to={`${process.env.PUBLIC_URL}/pages/login`} >{isLoggedIn?'Logout':'Login'}</Link>&nbsp;&nbsp;&nbsp;&nbsp;
                                    <i className="fa fa-bars menubar" ></i> <span className="menubar" style={{cursor: 'pointer', color: 'white'}} onClick={this.openNav}>Menu</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="main-nav">
                                    <NavBar pid={"5eb2d36b6c12b0a6fb2495c5"} 
                                            cartChange={this.state.cartChange}
                                            openNav={this.openNav}
                                            closeNav={this.closeNav}
                                            navClose={this.state.navClose}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </header>

                
            </div>
        )
    }
}

export default Header;